<div class="ion-page">
    <ion-content [scrollY]="false">
        <upp-scrollable class="login-scroll">
            <div class="login" [class.mobile]="view.Mobile">
                <div class='login-logo'>
                    <img [hidden]="view.LightTheme === true" src= "assets/image/unpispas-dark.png" alt="unpispas-dark">
                    <img [hidden]="view.LightTheme !== true" src= "assets/image/unpispas-light.png" alt="unpispas-light">
                </div>
                <div class="greeting">
                    <h1>{{tr('@login_welcome_back')}}</h1>
                    <h2>{{tr('@login_please_do_login')}}</h2>
                </div>
                <form class='login-form' [formGroup]="LoginForm" autocomplete="off" (submit)="DoLogin()" (keyup.enter)="DoLogin()">
                    <ion-list>
                        <ion-item lines="none">
                            <ion-icon color="medium" slot="start" name="person-outline"></ion-icon>
                            <upp-input uppDataid="login-username-text" 
                                formControlName="username" 
                                type="email" 
                                autocomplete="username" 
                                placeholder="{{tr('@login_username_placeholder')}}" 
                                title="{{tr('@login_username')}}" 
                                (Changed)="ResetError()"
                                [errornfo]="{ required: tr('@mandatory_field'), email: tr('@enter_valid_email') }"
                            ></upp-input>
                        </ion-item>  
                        <ion-item lines="none">
                            <ion-icon color="medium" slot="start" name="lock-closed-outline"></ion-icon>
                            <upp-input uppDataid="login-password-text" 
                                formControlName="password"
                                type="password"
                                autocomplete="current-password" 
                                placeholder="{{tr('@login_passsword_placeholder')}}" 
                                title="{{tr('@login_password')}}" 
                                (Changed)="ResetError()"
                                [errornfo]="{ required: tr('@mandatory_field'), minlength: tr('@minsize_field', [ '8' ]) }"
                            ></upp-input>
                        </ion-item>
                    </ion-list>
                    <ion-text color="danger" class="login-error" *ngIf="LoginError">
                        <h2 [hidden]="view.IsOnline === true">{{tr('@login_connection_error')}}</h2>
                        <h2 [hidden]="view.IsOnline !== true || DeviceBusy">{{tr('@login_not_authorized')}}</h2>
                        <h2 [hidden]="!DeviceBusy">{{tr('@login_nameinuse_message')}}</h2>
                    </ion-text>
                    <div *ngIf="NewDevice" style="margin: 30px 0px 10px 0px;">
                        <div class="greeting">
                            <h1>{{tr('@login_deviceid_first')}}</h1>
                            <h2>{{tr('@login_deviceid_unset')}}</h2>
                        </div>
                        <ion-list>
                            <ion-item lines="none">
                                <ion-icon color="medium" slot="start" name="laptop-outline"></ion-icon>
                                <upp-input uppDataid="login-deviceid-text"
                                    formControlName="deviceid"
                                    type="text"
                                    autocomplete="off"
                                    placeholder="{{tr('@login_deviceid_placeholder')}}"
                                    title="{{tr('@login_deviceid')}}"
                                    (Changed)="ResetError()"
                                    [errornfo]="{ required: tr('@mandatory_field') }"
                                ></upp-input>
                            </ion-item>
                        </ion-list>
                    </div>
                    <ion-item *ngIf="!IsPinpad" class="check" lines="none">
                        <ion-label color="medium">{{tr('@login_remember_me_check')}}</ion-label>
                        <ion-checkbox uppDataid="login-remember-check" 
                            formControlName="remember"
                            mode="md" 
                            slot="start"
                        ></ion-checkbox>
                    </ion-item>
                    <ion-button uppDataid="login-submit-button" type="submit" expand="block" size="large" style="margin:10px 0px 0px 0px;" [disabled]="!CanSubmit">
                        {{tr('@login_do_login_button')}}
                    </ion-button>
                    <ion-button uppDataid="login-recover-link" size="small" expand="block" fill="clear" color="primary" (click)="OpenRecover()">
                        {{tr('@login_link_recover')}}
                    </ion-button>
                    
                    <div *ngIf="!IsPinpad" class="option" style="margin-top:15px">
                        <ion-label>
                            <span class="small">{{tr('@login_create_user')}}</span>
                        </ion-label>
                        <ion-button uppDataid="login-register-button" style="margin-top:10px;" size="large" expand="block" fill="outline" color="primary" (click)="OpenRegister()">
                            {{tr('@login_link_newuser')}}
                        </ion-button>    
                    </div>
    
                    <ion-item *ngIf="!IsPinpad && view.Desktop && view.CanKiosk" class="check" lines="none">
                        <ion-label color="medium">{{tr('@login_use_kiosk')}}</ion-label>
                        <ion-toggle uppDataid="login-kiosk-toggle" 
                            formControlName="usekiosk"
                            color="primary" 
                            slot="end" 
                            (ionChange)="OnKiosk($event)"
                        ></ion-toggle>
                    </ion-item>
                </form>
            </div>
        </upp-scrollable>
    </ion-content>
</div>
